import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useOrganizations } from '../../hooks/useOrganizations';
import OrganizationsDashboard from '../../components/administracion/OrganizationsDashboard';

const OrganizacionesPage = () => {
  const { organizations, error, isLoading } = useOrganizations();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar organizaciones.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <OrganizationsDashboard
        windows={organizations}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de organizaciones:', newOrder);
        }}
      />
    </Box>
  );
};

export default OrganizacionesPage;